import { computed, ref } from 'vue';
import { SPORT_LIVE_TV_DEFAULT_SORT, SPORT_LIVE_TV_DEFAULT_STATUS, SPORT_LIVE_TV_STATUSES, createSportLiveTvEmptySelection } from '@/sport-live-tv/constants';

export const useSportLiveTvFilters = () => {
  const selection = ref(createSportLiveTvEmptySelection());
  const sort = ref(SPORT_LIVE_TV_DEFAULT_SORT);
  const status = ref(SPORT_LIVE_TV_DEFAULT_STATUS);
  const scoresVisible = ref(false);

  const isFiltered = computed(() => selection.value.leagues.length > 0 || selection.value.teams.length > 0);

  const applySelection = (nextSelection) => {
    selection.value = nextSelection;
  };

  const selectLeague = (leagueId) => {
    selection.value = { leagues: [leagueId], teams: [] };
  };

  const showLive = () => {
    status.value = SPORT_LIVE_TV_STATUSES.live;
  };

  const toggleScores = () => {
    scoresVisible.value = !scoresVisible.value;
  };

  const clearFilters = () => {
    selection.value = createSportLiveTvEmptySelection();
    sort.value = SPORT_LIVE_TV_DEFAULT_SORT;
    status.value = SPORT_LIVE_TV_DEFAULT_STATUS;
  };

  return { selection, sort, status, scoresVisible, isFiltered, applySelection, selectLeague, showLive, toggleScores, clearFilters };
};
